import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var MailSent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.388 10.34H11.724a1.69 1.69 0 0 0-1.703 1.704v3.91c0 .501.4.802.801.802a.79.79 0 0 0 .802-.802v-2.707l14.931 10.426c.3.2.702.2 1.002 0l14.931-10.426v19.649s0 .1-.1.1H11.724s-.1 0-.1-.1v-3.208a.79.79 0 0 0-.802-.802H7.015a.79.79 0 0 0-.802.802c0 .501.4.802.802.802h3.006v2.306a1.69 1.69 0 0 0 1.703 1.704h30.564a1.69 1.69 0 0 0 1.704-1.704V12.144a1.637 1.637 0 0 0-1.604-1.804ZM27.056 22.069l-14.23-10.025h28.56L27.056 22.07Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.51 20.164c0-.501.4-.802.801-.802h8.718a.79.79 0 0 1 .802.802c0 .401-.401.802-.802.802H5.411c-.5.1-.902-.3-.902-.802ZM0 24.876c0-.501.4-.802.802-.802h16.735c.5 0 .801.4.801.802a.79.79 0 0 1-.802.802H.802A.79.79 0 0 1 0 24.876Z"
  }));
});
MailSent.displayName = 'MailSent';
MailSent.defaultProps = {
  'aria-label': 'MailSent'
};
export default MailSent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/MailSent.js
// module id = 3829
// module chunks = 11